import React from 'react';
import { Link } from 'react-router-dom';

import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { UpliftIcon } from '@uplift/icons';

const useStyles = makeStyles()(theme => ({
  icon: {
    height: '36px',
    width: 'auto',
    color: theme.palette.darkSlate.main,
  }
}));


export const NavigationLogo: React.FC<{ href?: string }> = ({ href }) => {
  const { classes } = useStyles();

  if (href) {
    return (
      <Link to={href} style={{ display: 'flex', alignItems: 'center' }} data-testid="nav-logo-link">
        <UpliftIcon className={classes.icon} />
      </Link>
    );
  }


  return (
    <Box display="flex" alignItems="center" data-testid="nav-logo">
      <UpliftIcon className={classes.icon} />
    </Box>
  );
};
